export default "__VITE_ASSET__CfDRFE7t__"